export const ROOM_INVITATION_FIRST_DISABLE_QUERY_PARAM_NAME =
  "room:invitation-first:disable";
